import { render, staticRenderFns } from "./CustomerServiceSupervisorRequests.vue?vue&type=template&id=a537f222&"
import script from "./CustomerServiceSupervisorRequests.vue?vue&type=script&lang=js&"
export * from "./CustomerServiceSupervisorRequests.vue?vue&type=script&lang=js&"
import style0 from "./CustomerServiceSupervisorRequests.vue?vue&type=style&index=0&id=a537f222&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports